// components/common/DishCardSkeleton.jsx
import React from "react";
import Skeleton from "react-loading-skeleton";

const DishCardSkeleton = () => (
  <div className="dish-card">
    <div className="dish-image">
      <Skeleton
        variant="rectangular"
        width="100%"
        height={90}
        borderRadius={10}
      />
    </div>
    <div className="dish-content">
      <Skeleton variant="text" width="60%" height={30} />
      <Skeleton variant="text" width="80%" height={20} />
      <Skeleton variant="text" width="40%" height={20} />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={36}
        style={{ marginTop: 8 }}
      />
    </div>
  </div>
);

export default DishCardSkeleton;
